/* FO와 BO > LINKAGE_FAIL_USER_MESSAGES 공통 내용입니다. (업데이트 시 동일 작업 필수) */
import React from 'react';

/* 25.04.16 기준 노션 문서 현행화 */
// type: dataLinkageManage(데이터 연동 목록), scraping(스크래핑)
// 예외 케이스 - E11415 캡처 인증 발생은 사용자 메시지 사용 x
export const makeFailUserMessage = (errorCode, type, extraData) => {
  if (type === 'scraping') {
    switch (errorCode) {
      case 'E00500':
      case 'E11212':
      case 'E11311':
      case 'E11413':
      case 'E11414':
      case 'E11613':
      case 'E11711':
        return '현재 판매몰 연동이 원활하지 않습니다.\n고객센터로 문의해 주세요.';
      case 'E11211':
      case 'E11901':
        return '등록하신 계정은 이미 등록되어 있습니다.\n등록한 적이 없다면 계정을 다시 한번 확인해 주시거나, 고객센터로 문의해 주세요.';
      case 'E11321':
      case 'E11322':
      case 'E11411':
      case 'E11421':
      case 'E11511':
        return '판매몰 연동이 불가합니다.\n고객센터로 문의해 주세요.';
      case 'E11412':
        return '연동 판매몰의 로그인 계정 정보가 상이합니다.\n연동정보를 변경해 주세요.';
      case 'E11416':
      case 'E11612':
        return '현재 판매몰 데이터 연동 진행중입니다.\n잠시 후 연동상태를 확인해 주세요.';
      case 'E11417':
        return '판매몰의 계정이 잠겼습니다.\n해당 몰에 접속 후 잠금 해제를 진행해 주세요.';
      case 'E11418':
        return '판매몰의 비밀번호 재설정이 필요합니다.\n해당 몰에서 비밀번호를 재설정 해주세요.';
      case 'E11419':
        return '판매자 센터에 가입되지 않은 계정입니다. 판매자 센터에 가입된 계정으로 다시 한 번 연동을 진행해 주세요.';
      case 'E11420':
        return `판매몰 회원 정책으로 인해 로그인이 실패하였습니다.\n연동을 시도한 판매몰의 고객센터로 문의해주세요.`;
      case 'E11422':
        return '판매몰의 로그인 허용 IP 설정을 변경해야 합니다. 해당 몰에서 IP 설정을 해제해 주세요.';
      case 'E11423':
        return '유효한 QR코드가 아닙니다. 정확한 QR코드 이미지를 등록해 주세요.';
      case 'E11424':
        return '유효한 OTP번호가 아닙니다. 정확한 OTP번호를 입력해 주세요.';
      case 'E11611':
        return '현재 연동이 진행 중입니다. 잠시 후 다시 시도해주세요.';
      case 'E11900':
        return '2차 인증 해제가 완료되지 않았습니다.\n해당 몰에서 2차 인증 해제를 진행해 주세요.';
      case 'etc':
        return '판매몰 연동이 불가합니다.\n고객센터로 문의해 주세요.';
      default:
        return null;
    }
  } else if (type === 'dataLinkageManage') {
    switch (errorCode) {
      case 'FRT111':
        return (
          <span>
            연동 판매몰의 <strong>로그인 계정 정보가 상이</strong>합니다.
            <br />
            연동정보를 변경해 주세요.
          </span>
        );
      case 'FRT112':
      case 'FRT113':
      case 'FRT131':
      case 'FRT132':
      case 'FRT141':
      case 'FRT997':
      case 'FRT998':
      case 'FRT999':
        return (
          <span>
            현재 판매몰 연동이 원활하지 않습니다.
            <br />
            고객센터로 문의해 주세요.
          </span>
        );
      case 'FRT133':
        return (
          <span>
            판매몰 연동이 불가합니다.
            <br />
            고객센터로 문의해 주세요.
          </span>
        );
      case 'FRT134':
        return (
          <span>
            판매몰 내 사업자 번호가 존재하지 않습니다.
            <br />
            해당 몰에서 사업자 정보를 등록해 주세요.
          </span>
        );
      case 'FRT157':
        return (
          <span>
            판매몰의 <strong>캡차(captcha) 인증이 필요</strong>합니다.
            <br />
            문자로 전송된 URL에 접속 후 캡차 인증을 진행해 주세요.
          </span>
        );
      case 'FRT162':
        return (
          <span>
            판매몰의 비밀번호 재설정이 필요합니다.
            <br />
            해당 몰에서 비밀번호를 재설정 해주세요.
          </span>
        );
      case 'FRT172':
        return (
          <span>
            판매몰의 로그인 허용 IP 설정을 변경해야 합니다. 해당 몰에서 IP
            설정을 해제해 주세요.
          </span>
        );
      case 'FRT114':
      case 'FRT142':
      case 'FRT143':
        return (
          <span>
            현재 판매몰 연동이 원활하지 않습니다.
            <br />
            <strong>[연동 재요청하기] 버튼을 눌러 다시 연동을 시도</strong>해
            주세요.
            <br />
            <br />
            <span className="marker bulletPoint">
              연동 상태가 업데이트되는 데 시간이 소요될 수 있으니,
              <br />
              <span className="marker">
                [연동 최신화] 버튼을 눌러 상태 변경 여부를 확인해 주세요.
              </span>
            </span>
          </span>
        );
      case 'FRT121':
        return (
          <span>
            판매몰의 2차 인증이 실패하였습니다.
            <br />
            연동을 다시 한번 진행해 주세요.
          </span>
        );
      case 'FRT122':
      case 'FRT123':
        return (
          <span>
            판매몰의 2차 인증이 실패하였습니다.
            <br />
            고객센터로 문의해주세요.
          </span>
        );
      case 'FRT124':
        return (
          <span>
            판매몰의 2차 인증시간이 만료되었습니다.
            <br />
            연동을 다시 한번 진행해 주세요.
          </span>
        );
      case 'FRT125':
        if (extraData === 'SAM100') {
          return (
            <span>
              판매몰의 2차 인증 정보가 맞지않습니다.
              <br />
              2차 인증을 다시 한번 진행해 주세요.
            </span>
          );
        } else {
          return (
            <span>
              판매몰의 <strong>QR OTP 인증이 실패</strong>되었습니다.
              <br />
              인증을 다시 한번 진행해 주세요.
            </span>
          );
        }

      case 'FRT126':
        return (
          <span>
            판매몰의 2차 인증이 필요합니다.
            <br />
            문자로 전송된 URL에 접속 후 2차 인증을 진행해 주세요.
          </span>
        );
      case 'FRT127':
        return (
          <span>
            2차 인증이 유효하지 않습니다. 해당 몰에서 2차 인증 수신 정보를
            재설정 해주세요.
          </span>
        );
      case 'FRT128':
        return <span>2차 인증 진행이 취소되었습니다.</span>;
      case 'FRT129':
        return (
          <span>
            판매몰의 2차 인증을 수신받을 정보가 저장되어있지 않습니다. 해당
            몰에서 2차 인증 수신 정보를 재설정 해주세요.
          </span>
        );
      case 'FRT151':
        return (
          <span>
            판매몰의 캡차(captcha) 인증이 실패하였습니다.
            <br />
            연동을 다시 한번 진행해 주세요.
          </span>
        );
      case 'FRT155':
        return (
          <span>
            판매몰의 <strong>캡차(captcha) 인증시간이 만료</strong>되었습니다.
            <br />
            캡차 인증을 다시 한번 진행해 주세요.
          </span>
        );
      case 'FRT158':
        return (
          <span>
            판매몰의 캡차(captcha) 인증이 실패하였습니다.
            <br />
            연동을 다시 한번 진행해 주세요.
          </span>
        );
      case 'FRT161':
        return (
          <span>
            현재 판매몰의 계정이 잠김 상태 입니다.
            <br />
            해당 판매자 센터에 로그인 후 계정 잠금을 해제해 주세요.
          </span>
        );
      case 'FRT163':
        return (
          <span>
            현재 판매몰 연동시 인증 갱신을 필요로 합니다.
            <br />
            해당 판매자 센터에 로그인 후 인증 갱신을 진행해 주세요.
          </span>
        );
      case 'FRT164':
        return (
          <span>
            현재 판매몰 연동시 비밀번호 재설정을 필요로 합니다.
            <br />
            해당 판매자 센터에 로그인 후 비밀번호 재설정을 진행해 주세요.
          </span>
        );
      case 'FRT165':
        return (
          <span>
            판매자 센터에 가입되지 않은 계정입니다.
            <br />
            판매자 센터에 가입된 계정으로 다시 한번 연동을 진행해 주세요.
          </span>
        );
      case 'FRT167':
        return (
          <span>
            사업자 전환이 필요한 계정입니다.
            <br />
            해당 판매자 센터에 로그인 후 사업자 전환을 진행해 주세요.
          </span>
        );
      case 'FRT168':
        return (
          <span>
            현재 판매몰 로그인이 필요한 계정입니다. 해당 판매자 센터에 로그인 후
            내용을 확인해 주세요.
          </span>
        );
      case 'FRT169':
        return (
          <span>
            해당 판매몰 계정에 1건 이상의 스토어가 운영되고 있습니다. 고객센터로
            문의해 주세요.
          </span>
        );
      case 'FRT171':
        return (
          <span>
            반복된 2차 인증 시도로 인해 일시적으로 잠김 상태입니다.
            <br />
            잠시 후 '2차 인증 재요청하기' 버튼을 클릭 후 다시 한번 인증을
            진행해주세요.
            <br />
            (잠김 상태는 최대 30분동안 지속될 수 있습니다.)
          </span>
        );
      case 'etc':
        return (
          <span>
            판매몰 연동이 불가합니다.
            <br />
            고객센터로 문의해 주세요.
          </span>
        );
    }
  }
};

export const GUIDE_TEXT_BY_MALL_OPEN_YN = {
  N: {
    accountGuideText: '데이터 연동 요청이 완료됐어요.',
    completionGuideText: [
      '오픈 예정 몰은 정상 오픈 후 자동으로 연동되며,',
      '연동 결과를 문자로 안내드려요',
    ],
  },
  Y: {
    accountGuideText: '데이터 연동 요청이 완료됐어요.',
    completionGuideText: [`잠시 후 연동 결과가`, `문자로 발송될 예정이에요`],
  },
};
